import { Check } from "lucide-react";
import { api } from "../../lib/api";

// kind: "quotes" | "leads" | "applications"
export default function AdminRequestsTab({ kind, items, reload }) {
  const toggleHandled = async (id, handled) => {
    await api.patch(`/admin/${kind}/${id}`, { handled: !handled });
    reload();
  };

  if (kind === "applications") {
    return (
      <div className="rounded-2xl border border-border overflow-hidden">
        {items.map((item) => (
          <div key={item.id} data-testid={`app-row-${item.id}`} className="flex items-center justify-between px-5 py-4 border-b border-border last:border-0 gap-3">
            <div>
              <div className="font-semibold flex items-center gap-2">{item.name}
                <span className="font-mono-x text-[10px] tracking-widest px-2 py-0.5 rounded-full bg-primary/10 text-primary">{item.role}</span>
              </div>
              <div className="text-sm text-muted-foreground">
                {item.email}{item.phone ? ` · ${item.phone}` : ""}{item.location ? ` · ${item.location}` : ""}{item.experience ? ` · ${item.experience} yrs` : ""}
              </div>
              {item.message && <div className="text-sm text-muted-foreground mt-1">{item.message.slice(0, 120)}</div>}
            </div>
            <button data-testid={`app-handle-${item.id}`} onClick={() => toggleHandled(item.id, item.handled)}
              className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-semibold shrink-0 ${item.handled ? "bg-emerald-500/10 text-emerald-600" : "border border-border"}`}>
              {item.handled ? <><Check className="w-3.5 h-3.5" /> Handled</> : "Mark handled"}
            </button>
          </div>
        ))}
        {items.length === 0 && <div className="p-6 text-muted-foreground text-sm">No applications yet.</div>}
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-border overflow-hidden">
      {items.map((item) => (
        <div key={item.id} className="flex items-center justify-between px-5 py-4 border-b border-border last:border-0">
          <div>
            <div className="font-semibold">{item.name} <span className="text-muted-foreground font-normal">· {item.email}</span></div>
            <div className="text-sm text-muted-foreground">{kind === "quotes" ? `${item.service || ""} · ${item.origin || ""} → ${item.destination || ""}` : (item.message || "").slice(0, 80)}</div>
          </div>
          <button onClick={() => toggleHandled(item.id, item.handled)} className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-semibold ${item.handled ? "bg-emerald-500/10 text-emerald-600" : "border border-border"}`}>
            {item.handled ? <><Check className="w-3.5 h-3.5" /> Handled</> : "Mark handled"}
          </button>
        </div>
      ))}
      {items.length === 0 && <div className="p-6 text-muted-foreground text-sm">Nothing here yet.</div>}
    </div>
  );
}
